export const tankFarmSupplyRules = {
  supplyName: [{ required: true }], // 租单名称
  storageTankShape: [{ required: true }], // 储罐形状
  storageType: [{ required: true }], // 储存类型
  cargoName: [{ required: true }], // 货物名称
  leaseTime: [{ required: true }], // 起租日期
  companyName: [{ required: true }], // 公司名称
  linkMan: [{ required: true }], // 联系人
  telephone: [{ required: true }], // 手机号
  storageTankStandard: [{ required: true }], // 储罐规格
  storageTankHeight: [{ required: true }], // 储罐高度
  storageTankDiameter: [{ required: true }], // 储罐直径
  storageTankType: [{ required: true }], // 储罐型号
  leasePotCount: [{ required: true }], // 起租罐数
  tenantablePotCount: [{ required: true }], // 可租罐数
  expectPrice: [{ required: true }], // 租金
  leaseTerm: [{ required: true }], // 起租年限
  storageLocation: [{ required: true }], // 库房位置
  detailedLocation: [{ required: true }], // 详细位置
  potArea: [{ required: true }], // 罐区面积
  fireResistanceRating: [{ required: true }], // 罐区耐火级
  fireQualification: [{ required: true }], // 消防资质
  fireInformation: [{ required: true }], // 消防信息
  remarks: [{ required: true }] // 仓库简介
}

export const storageSupplyRules = {
  supplyName: [{ required: true }], // 租单名称
  warehouseType: [{ required: true }], // 仓库类型
  storageType: [{ required: true }], // 储存类型
  leaseTime: [{ required: true }], // 起租日期
  lettableArea: [{ required: true }], // 起租面积
  rentableArea: [{ required: true }], // 可租用面积
  expectPrice: [{ required: true }], // 租金
  leaseTerm: [{ required: true }], // 起租年限
  storageLocation: [{ required: true }], // 库房位置
  detailedLocation: [{ required: true }], // 详细位置
  coveredArea: [{ required: true }], // 建筑面积
  fireQualification: [{ required: true }], // 消防资质
  warehouseEquipment: [{ required: true }], // 库内设备（多选）
  floorTexture: [{ required: true }], // 地坪质地
  floorWeight: [{ required: true }], // 地坪承重
  landingPlatform: [{ required: true }], // 卸货平台
  companyName: [{ required: true }], // 公司名称
  linkMan: [{ required: true }], // 联系人
  telephone: [{ required: true }], // 手机号
  storageRecommend: [{ required: true }] // 仓库简介
}

export const storageDemandRules = {
  demandName: [{ required: true }], // 租单名称
  warehouseType: [{ required: true }], // 仓库类型
  storageType: [{ required: true }], // 储存类型
  demandArea: [{ required: true }], // 需求面积
  leaseStartTime: [{ required: true }], // 租赁开始日期
  leaseEndTime: [{ required: true }], // 租赁结束日期
  expectPrice: [{ required: true }], // 期望租金
  storageLocation: [{ required: true }], // 库房位置
  fireQualification: [{ required: true }], // 消防资质
  floorTexture: [{ required: true }], // 地坪质地
  warehouseEquipment: [{ required: true }], // 库内设备
  landingPlatform: [{ required: true }], // 卸货平台
  companyName: [{ required: true }], // 公司名称
  linkMan: [{ required: true }], // 联系人
  telephone: [{ required: true }], // 手机号
  // storageRecommend: [{ required: true }], // 仓库简介
  remarks: [{ required: false }] // 备注
}

export const tankFarmDemandRules = {
  demandName: [{ required: true }], // 需求名称
  storageType: [{ required: true }], // 储存类型
  leaseStartTime: [{ required: true }], // 租赁开始日期
  leaseEndTime: [{ required: true }], // 租赁结束日期
  goodsCubage: [{ required: true }], // 货物容积
  expectPrice: [{ required: true }], // 期望价格
  companyName: [{ required: true }], // 公司名称
  storageLocation: [{ required: true }], // 库房位置
  fireQualification: [{ required: true }], // 消防资质
  fireResistanceRating: [{ required: true }], // 罐区耐火等级
  linkMan: [{ required: true }], // 联系人
  telephone: [{ required: true }], // 手机号
  remarks: [{ required: true }] // 备注
}
